import { I18n } from '@affine/i18n';

export type LocalizedCopyParam = string | number | boolean | null;

export interface LocalizedCopy {
  key: string;
  params?: Record<string, LocalizedCopyParam>;
}

export function parseLocalizedCopy(value: unknown): LocalizedCopy | undefined {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return undefined;
  }
  const candidate = value as Record<string, unknown>;
  if (typeof candidate.key !== 'string' || !candidate.key.trim()) {
    return undefined;
  }
  if (candidate.params === undefined) {
    return { key: candidate.key };
  }
  if (
    !candidate.params ||
    typeof candidate.params !== 'object' ||
    Array.isArray(candidate.params)
  ) {
    return undefined;
  }
  const params = Object.fromEntries(
    Object.entries(candidate.params).filter(
      (entry): entry is [string, LocalizedCopyParam] => {
        const value = entry[1];
        return (
          value === null ||
          typeof value === 'string' ||
          typeof value === 'number' ||
          typeof value === 'boolean'
        );
      }
    )
  );
  return { key: candidate.key, params };
}

export function localizedCopy(
  copy: LocalizedCopy | undefined,
  fallback: string
): string {
  if (!copy) return fallback;
  const translated = I18n.t(copy.key, copy.params);
  return translated === copy.key ? fallback : translated;
}
